import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class HreflangService {
    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(DOCUMENT) private document: Document,
        private occService: OccEndpointsService
    ) { }

    /**
     * Loads localized URLs from API and injects canonical + hreflang tags.
     */
    loadAndSetLinks(productCode: string): void {
        if (!isPlatformBrowser(this.platformId)) return; // ✅ Prevent SSR error

        //const apiUrl = `https://api.catnw8-knorrbrem1-s2-public.model-t.cc.commerce.ondemand.com/occ/v2/APAC/`;

        this.http.get<string[]>(this.occService.buildUrl(`urlMapping?ProductCode=${productCode}`)).pipe(
            map(urls => urls.filter(url => !!url))
        ).subscribe(urls => {
            if (!urls.length) return;

            // Clean up old tags
            this.removeOldTags();
            const canonical = this.document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            canonical.setAttribute('href', window.location.href.split('?')[0]);
            this.document.head.appendChild(canonical);
            // Add hreflang links
            urls.forEach(url => {
                console.log(url);
                const langCode = this.extractLangCode(url); // e.g. en-GB or ja-JP
                if (langCode) {
                    const link = this.document.createElement('link');
                    link.setAttribute('rel', 'alternate');
                    link.setAttribute('hreflang', langCode);
                    link.setAttribute('href', url);
                    this.document.head.appendChild(link);
                }
                if (langCode === 'en_GB') {
                    const link = this.document.createElement('link');
                    link.setAttribute('rel', 'alternate');
                    link.setAttribute('hreflang', 'x-default');
                    link.setAttribute('href', url);
                    this.document.head.appendChild(link);
                }
            });
        });
    }

    private extractLangCode(url: string): string | null {
        // Example match: /JP/en_GB/JPY/  ->  en-GB
        try {
            const parts = url.split('/');
            return parts[4];
        } catch (e) {
            console.error('Error extracting language code:', e);
            return null;
        }
    }

    private removeOldTags(): void {
        const oldLinks = this.document.querySelectorAll(
            'link[rel="canonical"], link[rel="alternate"][hreflang]'
        );
        oldLinks.forEach(el => el.remove());
    }
}
